module.exports = __webpack_public_path__ + "static/peachBadgeRecWhite-eb567058dd3a57073ab885a473a0cf4b.png";